"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDesktop = exports.inIframe = exports.hasTouch = void 0;

// As "cssuseragent" is accessing the html dom object directly without checking whether it exists or not, we need to
// use old shool require() to have a conditional import only when html really exists. This avoids issues when
// running the UIKIT in a web-worker
if (document && document.documentElement) {
  // eslint-disable-next-line global-require
  require('cssuseragent');
}

var isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
}; // see https://patrickhlauke.github.io/touch/touchscreen-detection/ for reference


var hasTouch = function hasTouch() {
  if (window.PointerEvent && isDefined(navigator.maxTouchPoints)) {
    // if Pointer Events are supported, just check maxTouchPoints
    if (navigator.maxTouchPoints > 0) {
      return true;
    }
  } else if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
    // no Pointer Events...
    // check for any-pointer:coarse which mostly means touchscreen
    return true;
  } else if (window.TouchEvent || isDefined(window.ontouchstart)) {
    // last resort - check for exposed touch events API / event handler
    return true;
  }

  return false;
};

exports.hasTouch = hasTouch;

var isDesktop = function isDesktop() {
  return document && document.documentElement.classList.contains('ua-desktop');
};

exports.isDesktop = isDesktop;

var inIframe = function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

exports.inIframe = inIframe;